<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">
            <div id="titleArea">
                <div class="titleText">在校证明</div>
                <div class="titleButton">
                    <el-button class="custom-el-button" type="primary" @click="showHomePage">
                        <i class="el-icon-s-home"></i> 首页
                    </el-button>
                </div>
            </div>

            <div id="queryArea">
                <div class="filter-container">
                    <div class="formItem">
                        <el-select v-model="queryForm.auditState" placeholder="审核状态(全部)" style="width: 100%"
                            @change="handleFilter" clearable>
                            <el-option v-for="(item, index) in comboData.auditState" :key="item.comboValue"
                                :value="item.comboValue" :label="item.comboName">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="formItem text-center">
                        <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i> 重置</el-button>
                        <el-button @click="createCertificate" type="success"><i class="el-icon-circle-plus-outline"></i>
                            申请
                        </el-button>
                    </div>
                </div>
            </div>

            <div id="listArea" @scroll="handleScroll">
                <div v-if="tableData==null || tableData.length==0" class="cardTips">没有申请记录</div>
                <div class="cardMain" v-for="(item,index) in tableData" :key="index">
                    <div class="cardText">
                        <p><label for="">学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号：</label>{{ item.stuCode }}</p>
                        <p><label for="">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</label>{{ item.stuName }}</p>
                        <p><label for="">创建时间：</label>{{ item.cjsj }}</p>
                        <div class="auditStateImg">
                            <img :src="loadStateImg(item)" alt="">
                        </div>
                    </div>
                    <div class="cardInput">
                        <el-button v-if="item.auditState=='1'" @click="openDialog(item)" type="success">在校证明</el-button>
                        <el-button v-if="item.submitState == '0'" type="warning" @click="outsideSub(item)">提交
                        </el-button>
                        <el-button v-if="item.submitState=='1'" @click="showCertificateInfo('view', item)"
                            type="info">详情
                        </el-button>
                        <el-button v-if="item.submitState=='1' || item.auditState=='1'|| item.auditState=='2'"
                            @click="showAuditList(item)">审核信息
                        </el-button>
                    </div>
                </div>
                <div v-if="total>2 && total>tableData.length" id="loadingTips">
                    <i class="el-icon-loading"></i>&nbsp;信息加载中，请稍后...
                </div>
            </div>

            <el-dialog id="mainDialog" class="formDialog" title="在校证明申请" :visible.sync="applyDialogVisible" width="90%">
                <el-scrollbar id="mainDialogScroll" ref="mainDialogScroll">
                    <el-form ref="applyForm" :model="applyForm" label-width="84px" label-position="left" width="100%">
                        <el-form-item label="姓名">
                            {{applyForm.stuName}}
                        </el-form-item>
                        <el-form-item label="学号">
                            {{applyForm.stuCode}}
                        </el-form-item>
                        <div v-if="flag.viewFlag == true">{{applyForm.jssj}}</div>
                    </el-form>
                </el-scrollbar>
                <div slot="footer" class="dialog-footer text-center">
                    <el-button v-if="flag.setFlag" style="margin-left: 10px;" @click="submit()" type="warning">提交
                    </el-button>
                    <el-button v-if="flag.setFlag" style="margin-left: 10px;" @click="applyDialogVisible = false">取 消
                    </el-button>
                    <el-button v-if="!flag.setFlag" @click="applyDialogVisible = false">关 闭
                    </el-button>
                </div>
            </el-dialog>

            <el-dialog id="mainDialog" class="formDialog" :visible.sync="dialogVisible" @close="closeDialog">
                <el-scrollbar id="printDialogScroll" ref="printDialogScroll">
                    <el-form label-position="top">
                        <el-form-item>
                            <div style="height:680px;">
                                <previewer ref="previewer" :fileInfo="fileInfo" :height="650"></previewer>
                            </div>
                        </el-form-item>
                    </el-form>
                </el-scrollbar>
                <div slot="footer" class="dialog-footer text-center">
                    <el-button @click="fileDownload()" type="primary">导 出
                    </el-button>
                    <el-button style="margin-left: 10px;" @click="dialogVisible = false">关 闭
                    </el-button>
                </div>
            </el-dialog>

            <el-dialog class="formDialog" title="审核信息" :visible.sync="auditListDialogVisible"
                v-if="auditListDialogVisible" width="90%">
                <div>
                    <auditList ref="auditList" :relatedCode="certificateInfo.id" :listHeight="450"></auditList>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
    import {confirmMsg, showNotify} from "utils/message";
    import {globalConfig} from "static/config"
    import auditList from './auditList.vue';
    import previewer from "views/file/simplePreviewer";
    export default {
        components: {
            auditList,
            previewer
        },
        data() {
            return {
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    stuCode: "",
                    auditState: ""
                },
                comboData: {
                    auditState: []
                },
                userName: "",
                userCode: "",
                tableData: [],
                currentPage: 1,
                limit: 10,
                total: null,
                tableLoading: true,
                applyForm: {
                    stuName: "",
                    stuCode: "",
                    cjr: "",
                    zj: ""
                },
                applyDialogVisible: false,
                flag: {
                    viewFlag: false,
                    setFlag: false,
                },
                dialogVisible: false,
                htmlStr: "",
                printLoading: false,
                certificateInfo: {
                    auditParam: null,
                    auditLevel: null,
                    id: null,
                    cjr: null
                },
                auditListDialogVisible: false,
                fileInfo: {
                    name: '',
                    type: '',
                    url: ''
                },
            }
        },
        created() {
            this.init();
        },
        mounted() {},
        computed: {},
        methods: {
            async init() {
                await this.queryUserInfo();
                await this.initCombo();
            },
            queryUserInfo() {
                this.$api.system.basic.userInfo({}).then((res) => {
                    if (res.data.data) {
                        this.userName = res.data.data.name;
                        this.userCode = res.data.data.phone;

                        this.queryForm.stuCode = res.data.data.phone;
                        this.queryList();
                    } else {
                        this.userRole = '访客';
                        this.$router.push('/login');
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            initCombo() {
                this.$api.common.comboOption.auditState({})
                    .then((res) => {
                        this.comboData.auditState = res.data.data.comboData;
                    }).catch((err) => {
                        console.log(err);
                    });
            },
            async queryList() {
                this.tableLoading = true;
                this.queryForm.pageNum = this.currentPage;
                this.queryForm.rowNum = this.limit;

                await this.$api.certificate.atSchoolCertificate.queryListStu({
                    data: this.queryForm,
                }).then((response) => {
                    this.total = response.data.data.total;
                    this.tableData = this.tableData.concat(response.data.data.list);
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            handleScroll() {
                if (this.checkVisible() && !this.tableLoading && this.total > this.tableData.length) {
                    this.currentPage++;
                    this.queryList();
                }
            },
            checkVisible() {
                const ele = document.getElementById('loadingTips');
                if (ele) {
                    let rect = ele.getBoundingClientRect();
                    //获取当前浏览器的视口高度，不包括工具栏和滚动条
                    //document.documentElement.clientHeight兼容 Internet Explorer 8、7、6、5
                    let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                    //bottom top是相对于视口的左上角位置
                    //bottom大于0或者top-视口高度小于0可见
                    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
                } else {
                    return false;
                }
            },
            scrollToTop() {
                const ele = document.getElementById('listArea');
                if (ele) {
                    ele.scrollTop = 0;
                }
            },
            handleFilter() {
                this.scrollToTop();
                this.tableData.length = 0;
                this.currentPage = 1;
                this.queryList();
            },
            handleReset() {
                this.scrollToTop();
                this.tableData.length = 0;
                this.limit = 10;
                this.currentPage = 1;
                this.queryForm.auditState = null;
                this.tableLoading = false;
                this.queryList();
            },
            loadStateImg(row) {
                if (row.auditState === '1') {
                    //通过
                    return require('image/mobile/auditState/tg.png');
                } else if (row.auditState === '2') {
                    //驳回
                    return require('image/mobile/auditState/bh.png');
                } else {
                    if (row.submitState === '1') {
                        if (row.auditLevel === '1') {
                            //待审核
                            return require('image/mobile/auditState/dsh.png');
                        } else {
                            //审核中
                            return require('image/mobile/auditState/shz.png');
                        }
                    } else {
                        //未提交
                        return require('image/mobile/auditState/wtj.png');
                    }
                }
            },
            //创建申请
            createCertificate() {
                this.applyDialogTitle = "申请"
                this.applyForm.zj = "";
                this.$api.certificate.atSchoolCertificate.clickCreate({
                    data: this.userCode
                }).then((res) => {
                    if (res.data.data == "yes") {
                        this.applyForm.stuCode = this.userCode;
                        this.applyForm.stuName = this.userName;
                        this.flag.viewFlag = false;
                        this.flag.setFlag = true;
                        this.applyDialogVisible = true;
                    } else {
                        this.$alert(res.data.data, "提示", {
                            confirmButtonText: "确定",
							customClass: 'el-message-box-mobile',
                        });
                        return;
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            outsideSub(item){
                this.applyForm.zj = item.zj;
                this.submit();
            },
            //提交
            submit() {
                this.applyForm.submitState = '1';
                this.applyForm.auditState = '';
                this.applyForm.cjr = this.userCode;

                this.$api.certificate.atSchoolCertificate
                    .submit({
                        data: this.applyForm
                    }).then((res) => {
                        let state = res.data.data;
                        switch (state) {
                            case 'Success':
                                this.applyDialogVisible = false;
                                this.$notify({
                                    title: '成功',
                                    message: '提交成功',
                                    type: 'success',
                                    duration: 1500,
                                });
                                this.handleFilter();
                                break;
                            default:
                                this.$notify({
                                    title: '错误',
                                    message: "提交失败",
                                    type: 'error',
                                    duration: 3000,
                                });
                                break;
                        }
                    }).catch((err) => {
                        console.log(err);
                    });

                this.applyDialogVisible = false;
            },
            closeDialog() {
                this.$api.certificate.atSchoolCertificate.delTempFile({
                    data: this.fileInfo.name
                }).then((res) => {
                }).catch((err) => {
                    console.log(err);
                });
            },
            openDialog(row) {
                this.printLoading = true;
                this.applyForm.stuCode = row.stuCode;
                this.certificateInfo.id = row.zj
                this.$api.certificate.atSchoolCertificate.print({
                    data: {
                        stuCode: this.applyForm.stuCode,
                        relatedCode: this.certificateInfo.id,
                        state: null,
                    },
                })
                    .then((res) => {
                        this.fileInfo.name = res.data.data.fileName;
                        this.fileInfo.type = res.data.data.fileType;
                        this.fileInfo.url = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi + res.data.data.url;
                        this.fileName = res.data.data.fileName + '.' + res.data.data.fileType;
                        this.dialogVisible = true;
                    }).catch((err) => {
                    console.log(err);
                });
            },
            print() {
                confirmMsg('仅能打印一次，是否继续？', 'el-message-box-mobile').then(() => {
                    this.$api.certificate.atSchoolCertificate.updatePrintState({
                        data: this.applyForm.zj
                    }).then((res) => {
                        let win = window.open(" ");
                        win.document.write(this.htmlStr);
                        win.document.close();
                        win.print();
                        win.close();
                        this.dialogVisible = false;
                        this.handleFilter();
                    }).catch((err) => {
                        console.log(err);
                    });
                });
            },
            showLoadingMask(str) {
                this.loadingMask = this.$loading({
                    lock: true,
                    text: str,
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.8)",
                });
            },
            /**关闭loading**/
            closeLoadingMask() {
                if (this.loadingMask) this.loadingMask.close();
            },
            downloadFile(url, srcFilePath, fileName) {
                const _this = this;
                let xhr = new XMLHttpRequest();
                xhr.open("GET", url, true);
                xhr.responseType = 'blob';
                xhr.onload = function(e) {
                    var url = window.URL.createObjectURL(xhr.response);
                    var a = document.createElement('a');
                    a.href = url;
                    a.download = fileName;
                    a.click();
                    window.URL.revokeObjectURL(url);
                };
                xhr.onloadend = e => {
                    _this.delFile(srcFilePath);
                };
                xhr.send();
            },
            isExistFile(url) {
                if (url == null || url == undefined || url == "") {
                    return false;
                }
                let xmlhttp;
                if (window.XMLHttpRequest) {
                    xmlhttp = new XMLHttpRequest();
                } else {
                    xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
                }
                xmlhttp.open("GET", url, false);
                xmlhttp.send();
                if (xmlhttp.readyState == 4) {
                    if (xmlhttp.status == 200) return true;
                    //url存在xdinshenxin
                    else if (xmlhttp.status == 404) return false;
                    //url不存在
                    else return false; //其他状态
                }
            },
            delFile(srcFilePath) {
                const params = {
                    filePath: srcFilePath
                };

                this.$api.common.file.del({
                    data: params
                }).then((res) => {
                    /*
                    if(res.data.data.state == 'Success'){
                        showNotify('成功', '删除成功', 'success', 1500);
                    }else{
                        showNotify('错误', res.data.data.msg, 'error', 3000);
                    }
                    */
                }).catch((err) => {
                    console.log(err);
                });
            },
            showHomePage() {
                this.$router.push('/m/wx/home');
            },
            showCertificateInfo(type, row) {
                this.applyForm.stuName = row.stuName;
                this.applyForm.stuCode = row.stuCode;
                this.applyForm.zj = row.zj;
                // if (type == 'set') {
                //     this.flag.viewFlag = false;
                //     this.flag.setFlag = true;
                //     this.applyDialogVisible = true;
                // }

                if (type == 'view') {
                    this.applyDialogTitle = "详情"
                    this.flag.viewFlag = true;
                    this.flag.setFlag = false;
                    this.applyDialogVisible = true;
                }

                this.certificateInfo.id = row.zj;
                this.certificateInfo.auditLevel = row.auditLevel;
            },
            //显示审核详情列表
            showAuditList(row) {
                this.certificateInfo.id = row.zj;
                this.auditListDialogVisible = true;
            },
            printStateFormatter(row) {
                let str = '';
                if (row.printState === '0') {
                    str = '未打印';
                } else if (row.printState === '1') {
                    str = '已打印';
                }
                return str;
            },

            fileDownload() {
                const fileUrl = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi;
                this.showLoadingMask("导出中，请稍候...");
                this.$api.certificate.atSchoolCertificate.print({
                    data: {
                        stuCode: this.applyForm.stuCode,
                        relatedCode: this.certificateInfo.id,
                        state: null,
                    },
                }).then((res) => {
                        let furl = fileUrl+res.data.data.url;
                        //创建隐藏的下载链接
                        const link = document.createElement('a');
                        link.href = furl;
                        // link.target = '_blank';
                        // let fileName = rowData.fileName + '.' + rowData.fileType;
                        // link.setAttribute('download', fileName);
                        // 兼容性处理
                        if (navigator.userAgent.indexOf('Trident') > -1) { // IE浏览器
                            const ieDownloadFrame = document.createElement('iframe');
                            ieDownloadFrame.src = furl;
                            ieDownloadFrame.style.display = 'none';
                            document.body.appendChild(ieDownloadFrame);
                        } else if (navigator.userAgent.indexOf('Edge') > -1 || navigator.userAgent.indexOf('Edg') > -1) { // Edge浏览器
                            link.click(); // 直接触发链接点击事件
                        } else { // 其他浏览器
                            link.dispatchEvent(new MouseEvent('click'));
                        }
                }).catch((err) => {
                    console.log(err);
                }).finally(() => {
                    this.closeLoadingMask();
                });
            },
        }
    };
</script>

<style src="styles/mobile.css"></style>
<style scoped>
    #mobileMode {
        line-height: 0;
    }

    #mobileMode #queryDialog {
        top: 150px;
    }

    #mobileMode #mainDialogScroll {
        height: 25vh;
        padding: 10px 20px;
    }

    #mobileMode #printDialogScroll {
        height: 65vh;
        padding: 10px 20px;
    }

    #mobileMode #loadingTips {
        height: 30px;
        line-height: 30px;
        color: #9d9d9d;
        position: relative;
        bottom: 0;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// atSchoolCertificateStuMobile.vue?4e5f867e